// src/components/demo.tsx
import React, { useContext } from "react";
import { Container, Box, Stack, Heading, Text, Center } from "@chakra-ui/react";
import { AspectRatio } from "@chakra-ui/react";
import Video from "../components/video";
import { LanguageContext } from "../components/LanguageProvider"; // Import kontekstu językowego
import { messages } from "../intl/config"; // Import dostępnych tłumaczeń

function Demo() {
  const { locale = "en" } = useContext(LanguageContext); // Odczyt aktualnego języka z kontekstu
  const translations = messages[locale] || {}; // Ładowanie tłumaczeń zgodnie z aktualnym językiem

  return (
    <Container maxW={"7xl"} px={{ base: 4, md: 12 }} py={8} id="demo">
      <Stack flex={1} direction="column" py={{ base: 8, md: 12 }}>
        <Center>
          <Heading
            letterSpacing={1.1}
            fontWeight={600}
            fontSize={{ base: "2xl", sm: "3xl", lg: "5xl" }}
          >
            <Text as={"span"} color={"gray.700"}>
              {translations["demo.heading"] || "Default Heading"}
            </Text>
          </Heading>
        </Center>

        <Box
          position={"relative"}
          rounded={"2xl"}
          boxShadow={"md"}
          overflow={"auto"}
          borderColor="gray.700"
          padding={2}
        >
          <AspectRatio ratio={16 / 9}>
            <Video
              videoSrcURL="https://www.youtube.com/embed/BFwCXScOGf8?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=1&autoplay=0"
              videoTitle={translations["demo.videoTitle"] || "Default Video Title"}
            />
          </AspectRatio>
        </Box>
      </Stack>
    </Container>
  );
}

export default Demo;
